module.exports = __webpack_public_path__ + "static/history03-533c3f93fb80069b622ac5b5ce270ce9.png";